module.exports = __webpack_public_path__ + "static/assets/9d17df6ceed3b0f11c52b2ec3dfdb27a.png";